module.exports = __webpack_public_path__ + "static/media/mike-1-250x251.a9c14486.png";